import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import ProductsSection from './ProductsSection';
import Footer from './Footer';
import SiteNavbar from './SiteNavbar';
import ProjectsSlider from './ProjectsSlider';
import WhyChooseUsSection from './WhyChooseUsSection';
import ServicesSection from './ServicesSection';
// import FeaturedProductsSection from './components/FeaturedProductsSection';
import VideoSection from './VideoSection';

const HomeComponent = ()=>{
    return (
      <>
      <SiteNavbar />
      <HeroSection />
      <AboutSection />
      <ProjectsSlider />
      <ProductsSection />
      <ServicesSection/>
      <VideoSection />
      <WhyChooseUsSection />
      <Footer />
      </>
      )
}
export default HomeComponent;